import { DocumentRequestStatus } from '@/tsClient/servers/noodleDocuments/document-api-models';
import { FormStatus, INVOICE_STATUS, MESSAGE_ATTACHMENT_REFERENCE_TYPES } from '@typings/api-models';
import * as ApiModels from '@typings/api-models';

type Attachment = Pick<ApiModels.MessageAttachment, 'id'> & ApiModels.MessageAttachmentWithTypedData;

const isTaskSkipped = (attachment: Attachment): boolean => {
  if (attachment.referenceType === MESSAGE_ATTACHMENT_REFERENCE_TYPES.DOCUMENT_REQUEST_USER) {
    const documentRequestUser = attachment.data;
    return documentRequestUser.status === DocumentRequestStatus.SKIPPED;
  }
  if (attachment.referenceType === MESSAGE_ATTACHMENT_REFERENCE_TYPES.FORM_REQUEST) {
    const formData = attachment.data;
    return formData.status === FormStatus.SKIPPED;
  }
  if (attachment.referenceType === MESSAGE_ATTACHMENT_REFERENCE_TYPES.CREDIT_REPORT) {
    const creditReport = attachment.data;
    return !!creditReport.skippedAt;
  }
  if (attachment.referenceType === MESSAGE_ATTACHMENT_REFERENCE_TYPES.CUSTOM_TERMS) {
    const customTermsData = attachment.data;
    return Boolean(customTermsData.customTerms.skippedAt);
  }
  if (attachment.referenceType === MESSAGE_ATTACHMENT_REFERENCE_TYPES.INVOICE) {
    const invoiceData = attachment.data;
    return invoiceData.invoice.status === INVOICE_STATUS.SKIPPED;
  }
  if (attachment.referenceType === MESSAGE_ATTACHMENT_REFERENCE_TYPES.BOOKING) {
    const bookingData = attachment.data;
    return Boolean(bookingData.booking.skippedAt);
  }
  return false;
};

export default isTaskSkipped;
